// src/config/serviceCategories.js

export const SERVICE_CATEGORIES = [
    {
        key: "lavaggio",
        label: "Lavaggio",
        img: "/images/categoria_lavo_su.png",
        lavaggio: true,
        stiratura: false,
    },
    {
        key: "stiratura",
        label: "Stiratura",
        img: "/images/categoria_stiratura_su.png",
        lavaggio: false,
        stiratura: true,
    },
    {
        key: "entrambi",
        label: "Lavo & Stiro",
        img: "/images/categorie_lavostiro_su.png",
        lavaggio: true,
        stiratura: true,
    },
];

export const DEFAULT_SERVICE_KEY = "stiratura";

// mapping verso il DB (Servizi.jsx)
export const SERVICE_CATEGORY_DB_IDS = {
    stiratura: 1,
    lavaggio: 2,
    entrambi: 3,
};

export function getServiceFlags(key) {
    const found = SERVICE_CATEGORIES.find((c) => c.key === key);
    if (found) {
        return { lavaggio: found.lavaggio, stiratura: found.stiratura };
    }
    const def = SERVICE_CATEGORIES.find((c) => c.key === DEFAULT_SERVICE_KEY);
    return def
        ? { lavaggio: def.lavaggio, stiratura: def.stiratura }
        : { lavaggio: false, stiratura: true };
}

// key ("lavaggio") → id DB (2)
export function getDbIdFromKey(key) {
    if (!key) return null;
    return SERVICE_CATEGORY_DB_IDS[key] ?? null;
}

// id DB (2) → key ("lavaggio")
export function getKeyFromDbId(id) {
    const n = Number(id);
    const entry = Object.entries(SERVICE_CATEGORY_DB_IDS).find(
        ([, val]) => Number(val) === n
    );
    return entry ? entry[0] : null;
}
